import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './CSS/Technology.css';

const NewsList = () => {
  const [newsItems, setNewsItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await axios.get('https://weynibirhan.com.et/Economics.php');
        setNewsItems(res.data.data);
      } catch (error) {
        console.error("Failed to fetch news:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  return (
    <div className="news-container">
      <h2>Latest Economics News</h2>
      {loading ? (
        <p>Loading...</p>
      ) : (
        newsItems.map((item) => (
          <div className="news-card" key={item.id}>
            {item.image_url && <img src={`https://weynibirhan.com.et/${item.image_url}`} alt="News" />}
            <h3>{item.header}</h3>
            <p>{item.paragraph}</p>
            <span className="date">{new Date(item.created_at).toLocaleString()}</span>
          </div>
        ))
      )}
    </div>
  );
};

export default NewsList;
